import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { DOCUMENT_DROPZONE_ACCEPT } from '@/config/documentTypes';
import { KeenIcon } from '@/components';
import { toast } from 'sonner';
import uploadDocumentService from '@/services/document/uploadDocumentService';
import { useNavigate, useParams } from 'react-router-dom';
import { DefaultTooltip } from '@/components';
import { FormatFileSize, sanitizeRouteParam } from '@/utils';

// const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
// const MAX_TOTAL_SIZE = 1024 * 1024 * 1024;

// const ALLOWED_EXTENSIONS = [
//   'application/pdf',
//   'application/msword',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
//   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
// ];

// const DocumentUpload = () => {
//   const [uploadedFiles, setUploadedFiles] = useState([]);
//   const [loading, setLoading] = useState(false)
//   const { token } = useParams();
//   const navigate = useNavigate()
//   const [successMessage, setSuccessMessage] = useState(false)
//   const [errorMessage, setErrorMessage] = useState(false)
//   const [rejectedFiles, setRejectedFiles] = useState([]);
//   const [uploadErrors, setUploadErrors] = useState({});

//   useEffect(() => {
//     if (token) {
//       (async () => {
//         try {
//           await uploadDocumentService.verifyDocUploadToken(token);
//         } catch (error) {
//           if (error.message === "Invalid or expired token") {
//             toast.error('Invalid or expired Link.', {
//               description: 'Your Link has been expired. Please request again to get a new link.',
//             });
//             // navigate('/')
//             setErrorMessage(true)
//             return
//           }
//         }
//       })();
//     }
//   }, [token]);

//   const onDrop = useCallback((acceptedFiles, fileRejections) => {
//     if (acceptedFiles.length) {
//       setUploadedFiles(prev => {
//         const combined = [...prev, ...acceptedFiles].filter(
//           (file, index, self) =>
//             index === self.findIndex(f => f.name === file.name && f.size === file.size)
//         );

//         // calculate total size
//         const totalSize = combined.reduce((acc, file) => acc + file.size, 0);

//         if (totalSize > MAX_TOTAL_SIZE) {
//           toast.warning("Upload Limit Reached", {
//             description: "The total size of your selected documents is over 1 GB. Please remove some files or upload them in smaller batches.",
//           });

//           return prev; // keep old files, reject new additions
//         }

//         return combined;
//       });
//     }

//     if (fileRejections.length) {
//       setRejectedFiles(prev =>
//         [...prev, ...fileRejections].filter(
//           (rej, index, self) =>
//             index === self.findIndex(r => r.file.name === rej.file.name && r.file.size === rej.file.size)
//         )
//       );
//     }
//   }, []);


//   const removeFile = (name) => {
//     setUploadedFiles(prev => prev.filter(file => file.name !== name));
//   };

//   const removeRejectedFile = (name) => {
//     setRejectedFiles(prev => prev.filter(({ file }) => file.name !== name));
//   };

//   const removeAll = () => {
//     setUploadedFiles([]);
//   };

//   const {
//     getRootProps,
//     getInputProps,
//     fileRejections,
//     isDragActive,
//   } = useDropzone({
//     onDrop,
//     multiple: true,
//     // maxSize: MAX_FILE_SIZE,
//     accept: ALLOWED_EXTENSIONS.reduce((acc, type) => {
//       acc[type] = [];
//       return acc;
//     }, {}),
//   });


//   const handleSubmitDoc = async () => {
//     setLoading(true)
//     if (!token) {
//       toast.error('Invalid or expired Link.');
//       return;
//     }

//     const formData = new FormData();
//     uploadedFiles.forEach(file => {
//       formData.append('files[]', file);
//     });

//     try {
//       const { status } = await uploadDocumentService.uploadDocument(formData, token);
//       if (status) {
//         toast.success('Documents uploaded successfully!', {
//           description: 'Documents uploaded successfully. Your documents are now in the processing queue. This may take a few moments — please wait.',
//         });
//         setUploadedFiles([]);
//         setSuccessMessage(true)
//         // navigate('/')
//       }
//     } catch (error) {
//       console.error('Upload error:', error);
//       if (error.error === "Google Drive integration not found.") {
//         toast.warning('Google Drive Not Found.', {
//           description: 'Please Connect Google Drive to upload documents.',
//         });
//         return
//       }
//       if (error.message === '422 Unprocessable Entity. Validation failed.') {
//         console.log('asd');

//         const fileErrorMap = {};

//         Object.entries(error.errors).forEach(([key, messages]) => {
//           const indexMatch = key.match(/^files\.(\d+)/);
//           if (indexMatch) {
//             const fileIndex = parseInt(indexMatch[1], 10);
//             const file = uploadedFiles[fileIndex];
//             if (file) {
//               fileErrorMap[file.name] = messages.join(' ');
//             }
//           }
//         });

//         setUploadErrors(fileErrorMap);

//         toast.error('Some files failed validation.', {
//           description: 'Please review the errors below and try again.',
//         });

//         return;
//       }
//       toast.error('Document upload failed.', {
//         description: 'Something went wrong while uploading your document. Please try again.',
//       });
//     } finally {
//       setLoading(false)
//     }
//   };

//   return (
//     <>
//       {successMessage ? (
//         <div className='w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md  transition border-success bg-success-light'>
//           <p className='text-xl font-medium text-success-active'>Documents uploaded successfully!</p>
//           <p className='mt-1 text-xs'>Your documents are now in the processing queue. <br /> you may close this window</p>
//         </div>
//       ) : errorMessage ? (
//         <div className="w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md transition border-danger bg-danger-light">
//           <p className='text-xl font-medium text-danger-active'>Invalid or expired Link Used!</p>
//           <p className='mt-1 text-xs'>Please request again to get a new link <br /> you may close this window</p>
//         </div>
//       ) : (
//         <div className="max-w-[500px] mx-auto h-full flex flex-col items-center justify-center mb-2.5">
//           <div
//             {...getRootProps()}
//             className={`min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md cursor-pointer transition ${isDragActive ? 'border-primary bg-primary-light' : 'border-gray-300'
//               }`}
//           >
//             <input {...getInputProps()} />
//             {
//               isDragActive ? (
//                 <p>Drop the file here...</p>
//               ) : (
//                 <p className='text-base'>Drag & drop a document here, or click to select one<br />
//                   <span className="text-xs text-gray-500">Allowed: PDF, DOC, DOCX, XLSX</span>
//                 </p>
//               )
//             }
//           </div>

//           {rejectedFiles.length > 0 && (
//             <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-2 rounded-lg text-red-600 mt-4 w-full max-w-[480px] max-h-[250px] overflow-auto my-5 custom-scrollbar pr-1">
//               <div className="flex items-center justify-between mb-2">
//                 <h3 className="font-semibold text-gray-800">Rejected Files</h3>
//                 <button
//                   onClick={() => setRejectedFiles([])}
//                   className="text-sm text-danger hover:underline"
//                 >
//                   Remove All
//                 </button>
//               </div>
//               <ul className="flex flex-wrap justify-between gap-2">
//                 {rejectedFiles.map(({ file, errors, index }) => (
//                   <li
//                     key={`${file.name}-${index}`}
//                     className="w-[49%] flex items-center justify-between p-2 border border-danger-clarity rounded shadow-sm bg-danger-light"
//                   >
//                     <div className='max-w-[85%]'>
//                       {/* <span className="text-sm text-gray-700 truncate max-w-[70%]">{file.name}</span> */}
//                       <span className="text-sm text-gray-700 truncate line-clamp-1">
//                         <DefaultTooltip title={file.name} placement="left" className="w-fit">
//                           {file.name}
//                         </DefaultTooltip>
//                       </span>
//                       {errors.map((e, i) => {
//                         let message = e.message;
//                         if (e.code === 'file-invalid-type') {
//                           message = 'Invalid file type. Only PDF, DOC, DOCX and XLSX files are allowed.';
//                         } else if (e.code === 'file-too-large') {
//                           message = 'File is too large. Maximum allowed size is 5MB.';
//                         }
//                         return (
//                           <p key={i} className="text-[11px] leading-[1.4em] text-danger ml-1">- {message}</p>
//                         );
//                       })}
//                     </div>
//                     <button
//                       onClick={() => removeRejectedFile(file.name)}
//                       className="text-xs text-danger hover:underline"
//                     >
//                       <KeenIcon icon="trash" className="w-4 h-4" />
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {uploadedFiles.length > 0 && (
//             <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-2 rounded-lg w-full max-w-[480px] max-h-[150px] overflow-auto my-5 custom-scrollbar pr-1">
//               <div className="flex items-center justify-between mb-2">
//                 <h3 className="font-semibold text-gray-800">Uploaded Files</h3>
//                 <button
//                   onClick={removeAll}
//                   className="text-sm text-danger hover:underline"
//                 >
//                   Remove All
//                 </button>
//               </div>
//               <ul className="flex flex-wrap justify-between gap-2">
//                 {uploadedFiles.map((file, index) => (
//                   console.log('file', file),

//                   <li
//                     key={`${file.name}-${index}`}
//                     className="w-[49%] flex items-center justify-between p-2 border border-primary-clarity text-primary rounded shadow-sm"
//                   >
//                     <div className='pr-1 max-w-[70%]'>
//                       <span className="text-sm text-gray-700 truncate line-clamp-1">
//                         <DefaultTooltip title={file.name} placement="top" className="w-fit">
//                           {file.name}
//                         </DefaultTooltip>
//                       </span>
//                       <span className="mt-1.5 truncate badge badge-xs text-[11px] badge-outline badge-primary">Size: {FormatFileSize(file.size)}</span>
//                       {uploadErrors[file.name] && (
//                         <p className="text-[11px] leading-[1.4em] text-danger mt-1">{uploadErrors[file.name]}</p>
//                       )}
//                     </div>
//                     <button
//                       onClick={() => removeFile(file.name)}
//                       className="text-xs text-danger hover:underline"
//                     >
//                       <KeenIcon icon="trash" className="w-4 h-4" />
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           <button disabled={uploadedFiles.length === 0 || loading} onClick={handleSubmitDoc} className='justify-center w-full text-center btn btn-primary'>
//             {loading ? 'Uploading...' : 'Upload Document'}
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

// export { DocumentUpload };

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
const MAX_TOTAL_SIZE = 2 * 1024 * 1024 * 1024; // 2GB


const DocumentUpload = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token: rawToken } = useParams();
  const token = sanitizeRouteParam(rawToken);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [uploadErrors, setUploadErrors] = useState({});

  useEffect(() => {
    if (token) {
      (async () => {
        try {
          await uploadDocumentService.verifyDocUploadToken(token);
        } catch (error) {
          if (error.message === "Invalid or expired token") {
            toast.error('Invalid or expired Link.', {
              description: 'Your Link has been expired. Please request again to get a new link.',
            });
            setErrorMessage(true);
            return;
          }
        }
      })();
    }
  }, [token]);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (acceptedFiles.length) {
      setUploadedFiles(prev => {
        const combined = [...prev, ...acceptedFiles].filter(
          (file, index, self) =>
            index === self.findIndex(f => f.name === file.name && f.size === file.size)
        );

        // Check individual file size
        const fileExceedsLimit = combined.some(file => file.size > MAX_FILE_SIZE);
        if (fileExceedsLimit) {
          toast.warning("File Size Limit Exceeded", {
            description: `Each file must be ${FormatFileSize(MAX_FILE_SIZE)}. Please remove the large files.`,
          });
          return prev; // reject new files if any exceeds the limit
        }

        // Calculate total size
        const totalSize = combined.reduce((acc, file) => acc + file.size, 0);

        if (totalSize > MAX_TOTAL_SIZE) {
          toast.warning("Upload Limit Reached", {
            description: "The total size of your selected documents is over 2GB. Please remove some files or upload them in smaller batches.",
          });
          return prev; // keep old files, reject new additions
        }

        return combined;
      });
    }

    if (fileRejections.length) {
      setRejectedFiles(prev =>
        [...prev, ...fileRejections].filter(
          (rej, index, self) =>
            index === self.findIndex(r => r.file.name === rej.file.name && r.file.size === rej.file.size)
        )
      );
    }
  }, []);

  const removeFile = (name) => {
    setUploadedFiles(prev => prev.filter(file => file.name !== name));
  };

  const removeRejectedFile = (name) => {
    setRejectedFiles(prev => prev.filter(({ file }) => file.name !== name));
  };

  const removeAll = () => {
    setUploadedFiles([]);
  };

  const {
    getRootProps,
    getInputProps,
    fileRejections,
    isDragActive,
  } = useDropzone({
    onDrop,
    multiple: true,
    accept: DOCUMENT_DROPZONE_ACCEPT,
  });

  const handleSubmitDoc = async () => {
    setLoading(true);
    if (!token) {
      toast.error('Invalid or expired Link.');
      return;
    }

    const formData = new FormData();
    uploadedFiles.forEach(file => {
      formData.append('files[]', file);
    });

    try {
      const { status } = await uploadDocumentService.uploadDocument(formData, token);
      if (status) {
        toast.success('Documents uploaded successfully!', {
          description: 'Documents uploaded successfully. Your documents are now in the processing queue. This may take a few moments — please wait.',
        });
        setUploadedFiles([]);
        setSuccessMessage(true);
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Document upload failed.', {
        description: 'Something went wrong while uploading your document. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Display success/error messages */}
      {successMessage ? (
        <div className="w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md  transition border-success bg-success-light">
          <p className='text-xl font-medium text-success-active'>Documents uploaded successfully!</p>
          <p className='mt-1 text-xs'>Your documents are now in the processing queue. <br /> you may close this window</p>
        </div>
      ) : errorMessage ? (
        <div className="w-full max-w-[500px] min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md transition border-danger bg-danger-light">
          <p className='text-xl font-medium text-danger-active'>Invalid or expired Link Used!</p>
          <p className='mt-1 text-xs'>Please request again to get a new link <br /> you may close this window</p>
        </div>
      ) : (
        <div className="max-w-[500px] mx-auto h-full flex flex-col items-center justify-center mb-2.5">
          <div
            {...getRootProps()}
            className={`min-w-[480px] text-center border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md cursor-pointer transition ${isDragActive ? 'border-primary bg-primary-light' : 'border-gray-300'
              }`}
          >
            <input {...getInputProps()} />
            {
              isDragActive ? (
                <p>Drop the file here...</p>
              ) : (
                <p className='text-base'>Drag & drop a document here, or click to select one<br />
                  <span className="text-xs text-gray-500">Allowed: PDF, DOC, DOCX, XLSX</span> <br />
                  <span className="text-xs text-gray-500">Max size: 50MB (Each file) | Max total size: 2GB</span>
                </p>
              )
            }
          </div>

          {/* Rejected files */}
          {rejectedFiles.length > 0 && (
            <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-2 rounded-lg text-red-600 mt-4 w-full max-w-[480px] max-h-[250px] overflow-auto my-5 custom-scrollbar pr-1">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-800">Rejected Files</h3>
                <button
                  onClick={() => setRejectedFiles([])}
                  className="text-sm text-danger hover:underline"
                >
                  Remove All
                </button>
              </div>
              <ul className="flex flex-wrap justify-between gap-2">
                {rejectedFiles.map(({ file, errors, index }) => (
                  <li
                    key={`${file.name}-${index}`}
                    className="w-[49%] flex items-center justify-between p-2 border border-danger-clarity rounded shadow-sm bg-danger-light"
                  >
                    <div className='max-w-[85%]'>
                      <span className="text-sm text-gray-700 truncate line-clamp-1">
                        <DefaultTooltip title={file.name} placement="left" className="w-fit">
                          {file.name}
                        </DefaultTooltip>
                      </span>
                      {errors.map((e, i) => {
                        let message = e.message;
                        if (e.code === 'file-invalid-type') {
                          message = 'Invalid file type. Only PDF, DOC, DOCX and XLSX files are allowed.';
                        } else if (e.code === 'file-too-large') {
                          message = `File is too large. Maximum allowed size is ${FormatFileSize(MAX_FILE_SIZE)}.`;
                        }
                        return (
                          <p key={i} className="text-[11px] leading-[1.4em] text-danger ml-1">- {message}</p>
                        );
                      })}
                    </div>
                    <button
                      onClick={() => removeRejectedFile(file.name)}
                      className="text-xs text-danger hover:underline"
                    >
                      <KeenIcon icon="trash" className="w-4 h-4" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Uploaded files */}
          {uploadedFiles.length > 0 && (
            <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-2 rounded-lg w-full max-w-[480px] max-h-[150px] overflow-auto my-5 custom-scrollbar pr-1">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-800">Uploaded Files</h3>
                <button
                  onClick={removeAll}
                  className="text-sm text-danger hover:underline"
                >
                  Remove All
                </button>
              </div>
              <ul className="flex flex-wrap justify-between gap-2">
                {uploadedFiles.map((file, index) => (
                  <li
                    key={`${file.name}-${index}`}
                    className="w-[49%] flex items-center justify-between p-2 border border-primary-clarity text-primary rounded shadow-sm"
                  >
                    <div className='pr-1 max-w-[70%]'>
                      <span className="text-sm text-gray-700 truncate line-clamp-1">
                        <DefaultTooltip title={file.name} placement="top" className="w-fit">
                          {file.name}
                        </DefaultTooltip>
                      </span>
                      <span className="mt-1.5 truncate badge badge-xs text-[11px] badge-outline badge-primary">Size: {FormatFileSize(file.size)}</span>
                      {uploadErrors[file.name] && (
                        <p className="text-[11px] leading-[1.4em] text-danger mt-1">{uploadErrors[file.name]}</p>
                      )}
                    </div>
                    <button
                      onClick={() => removeFile(file.name)}
                      className="text-xs text-danger hover:underline"
                    >
                      <KeenIcon icon="trash" className="w-4 h-4" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Upload button */}
          <button disabled={uploadedFiles.length === 0 || loading} onClick={handleSubmitDoc} className='justify-center w-full text-center btn btn-primary'>
            {loading ? 'Uploading...' : 'Upload Document'}
          </button>
        </div>
      )}
    </>
  );
};

export { DocumentUpload };
